import React, { FunctionComponent } from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image"; // highlight-line
import { HTMLCustomProps } from "../../../types/css";

const Logo: FunctionComponent<HTMLCustomProps<HTMLImageElement>> = ({
  ...rest
}) => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "iwasaki.png" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <Img
      fluid={data.placeholderImage.childImageSharp.fluid}
      css={{ width: "33px", height: "23px" }}
      imgStyle={{
        objectFit: "fill",
        objectPosition: "50% 50%",
      }}
    />
  );
};

export default Logo;
